import React, { useState } from 'react';
import { FiSearch, FiX, FiPlus, FiList, FiFileText } from 'react-icons/fi';
import { FaUniversity } from 'react-icons/fa';
import BankSidebar from '../components/BankSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [
  { ref: '23', label: 'Miscellaneous pay...', date: '01/19/2026', value: '01/19/2026', method: 'Cash', bank: 'BOC', entry: '107', acc: '624 - Transport of goods and public transport of personnel', debit: '500.00', credit: '' },
  { ref: '21', label: 'Salary', date: '01/12/2026', value: '01/12/2026', method: 'Cash', bank: 'BOC', entry: '105', acc: '64 - Staff costs', debit: '15,000.00', credit: '' },
  { ref: '20', label: 'Salary', date: '12/11/2025', value: '12/11/2025', method: 'Cash', bank: 'BOC', entry: '104', acc: '64 - Staff costs', debit: '7,500.00', credit: '' },
  { ref: '19', label: 'Miscellaneous pay...', date: '11/12/2025', value: '11/12/2025', method: 'Cash', bank: 'BOC', entry: '103', acc: '624 - Transport of goods and public transport of personnel', debit: '2,000.00', credit: '' },
  { ref: '18', label: 'Miscellaneous pay...', date: '11/09/2025', value: '11/09/2025', method: 'Cash', bank: 'BOC', entry: '102', acc: '618 - Various', debit: '2,500.00', credit: '' },
  { ref: '17', label: 'Salary', date: '11/08/2025', value: '11/08/2025', method: 'Cash', bank: 'BOC', entry: '101', acc: '64 - Staff costs', debit: '8,600.00', credit: '' },
  { ref: '16', label: 'Salary', date: '10/08/2025', value: '10/08/2025', method: 'Cash', bank: 'BOC', entry: '100', acc: '64 - Staff costs', debit: '10,000.00', credit: '' },
  { ref: '13', label: 'Salary', date: '09/08/2025', value: '09/08/2025', method: 'Cash', bank: 'BOC', entry: '97', acc: '64 - Staff costs', debit: '2,200.00', credit: '' },
  { ref: '15', label: 'Salary', date: '08/05/2025', value: '08/05/2025', method: 'Cash', bank: 'BOC', entry: '99', acc: '64 - Staff costs', debit: '5,000.00', credit: '' },
  { ref: '14', label: 'Miscellaneous pay...', date: '06/30/2025', value: '06/30/2025', method: 'Cash', bank: 'BOC', entry: '98', acc: '625 - Travel, missions and receptions', debit: '500.00', credit: '' },
];

export default function MiscPayments() {
  const [data, setData] = useLocalState('misc_payments_data_v2', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });

  const handleAdd = (newData) => {
    setData([{ ...newData, debit: newData.debit || '0.00', credit: newData.credit || '' }, ...data]);
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const sortedData = sortData(data, sortConfig);
  const totalDebit = sortedData.reduce((acc, row) => acc + parseFloat((row.debit || '0').replace(/,/g, '')), 0);
  const totalCredit = sortedData.reduce((acc, row) => acc + parseFloat((row.credit || '0').replace(/,/g, '')), 0);

  const SortIcon = ({ column }) => {
    if (sortConfig.key !== column) return <span className="text-[10px] text-gray-400 opacity-0 group-hover:opacity-100 ml-1">▲</span>;
    return <span className="text-[10px] text-black ml-1">{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>;
  };

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <BankSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1 text-gray-800">
          <div className="flex items-center space-x-2">
            <span className="bg-[#e6f28b] text-[#8b8b00] px-1 border border-[#c4c400] text-[10px] font-bold shadow-sm">
              $==
            </span>
            <span className="font-medium text-[15px] text-teal-700">Miscellaneous payments ({data.length})</span>
          </div>
          <div className="flex items-center space-x-2">
            <select className="border border-gray-400 bg-white py-1 px-2 text-sm rounded-sm outline-none w-16">
              <option>20</option>
            </select>
            <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded shadow-sm hover:bg-blue-900 transition-colors">
              <FiPlus className="text-lg font-bold" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-x-auto bg-white border border-black shadow-sm">
          <table className="min-w-full border-collapse text-[12px] text-gray-800">
            <thead>
              <tr className="bg-[#a6e4e7]">
                <td className="border border-black p-1.5"><input type="text" className="w-full border border-gray-300 p-1 bg-white outline-none h-7 shadow-inner" /></td>
                <td className="border border-black p-1.5"><input type="text" className="w-full border border-gray-300 p-1 bg-white outline-none h-7 shadow-inner" /></td>
                <td className="border border-black p-1.5 w-32">
                  <div className="flex flex-col space-y-1">
                    <div className="flex items-center bg-white border border-gray-300 shadow-inner"><input type="text" placeholder="From" className="w-full p-1 text-[10px] outline-none text-gray-400" /><span className="px-1 text-gray-300 bg-gray-50 border-l border-gray-300 text-[10px]">📅</span></div>
                    <div className="flex items-center bg-white border border-gray-300 shadow-inner"><input type="text" placeholder="to" className="w-full p-1 text-[10px] outline-none text-gray-400" /><span className="px-1 text-gray-300 bg-gray-50 border-l border-gray-300 text-[10px]">📅</span></div>
                  </div>
                </td>
                <td className="border border-black p-1.5 w-32">
                  <div className="flex flex-col space-y-1">
                    <div className="flex items-center bg-white border border-gray-300 shadow-inner"><input type="text" placeholder="From" className="w-full p-1 text-[10px] outline-none text-gray-400" /><span className="px-1 text-gray-300 bg-gray-50 border-l border-gray-300 text-[10px]">📅</span></div>
                    <div className="flex items-center bg-white border border-gray-300 shadow-inner"><input type="text" placeholder="to" className="w-full p-1 text-[10px] outline-none text-gray-400" /><span className="px-1 text-gray-300 bg-gray-50 border-l border-gray-300 text-[10px]">📅</span></div>
                  </div>
                </td>
                <td className="border border-black p-1.5"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-black p-1.5"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-black p-1.5"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-black p-1.5"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-black p-1.5 min-w-[200px]"><select className="w-full border border-gray-300 p-1 bg-[#a6e4e7] outline-none h-7"><option></option></select></td>
                <td className="border border-black p-1.5">
                  <div className="flex items-center bg-[#a6e4e7] border border-gray-300 h-7"><span className="px-1 text-[10px] text-teal-800">∴</span><input type="text" className="w-full bg-transparent outline-none p-1" /></div>
                </td>
                <td className="border border-black p-1.5 w-24"><input type="text" className="w-full border border-gray-300 p-1 bg-white outline-none h-7 shadow-inner" /></td>
                <td className="border border-black p-1.5 w-24"><input type="text" className="w-full border border-gray-300 p-1 bg-white outline-none h-7 shadow-inner" /></td>
                <td className="border border-black p-1.5 text-center w-16">
                  <div className="flex justify-center space-x-2 text-lg font-bold">
                    <FiSearch className="text-black cursor-pointer hover:opacity-70" />
                    <FiX className="text-black cursor-pointer hover:opacity-70" />
                  </div>
                </td>
              </tr>
              <tr className="bg-[#a6e4e7] text-teal-900 select-none">
                <th onClick={() => handleSort('ref')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group">Ref. <SortIcon column="ref" /></th>
                <th onClick={() => handleSort('label')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group">Label <SortIcon column="label" /></th>
                <th onClick={() => handleSort('date')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group whitespace-nowrap">Date of<br/>payment <SortIcon column="date" /></th>
                <th onClick={() => handleSort('value')} className="font-normal p-2 border border-black text-left text-teal-700 cursor-pointer hover:bg-teal-200 group">Value date <SortIcon column="value" /></th>
                <th className="font-normal p-2 border border-black text-left text-teal-700">Payment met...</th>
                <th className="font-normal p-2 border border-black text-left text-teal-700">Project</th>
                <th className="font-normal p-2 border border-black text-left text-teal-700">Bank account</th>
                <th className="font-normal p-2 border border-black text-left text-teal-700">Bank entry</th>
                <th className="font-normal p-2 border border-black text-left text-teal-700">Account</th>
                <th className="font-normal p-2 border border-black text-left text-teal-700">Subledger...</th>
                <th onClick={() => handleSort('debit')} className="font-normal p-2 border border-black text-right text-teal-700 cursor-pointer hover:bg-teal-200 group">Debit <SortIcon column="debit" /></th>
                <th onClick={() => handleSort('credit')} className="font-normal p-2 border border-black text-right text-teal-700 cursor-pointer hover:bg-teal-200 group">Credit <SortIcon column="credit" /></th>
                <th className="font-normal p-2 border border-black text-center text-teal-700"><FiList className="inline text-black" /></th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black text-gray-800 whitespace-nowrap">
                    <span className="bg-[#e6f28b] text-[#8b8b00] px-1 border border-[#c4c400] text-[9px] font-bold mr-1.5 inline-block">
                      $==
                    </span>
                    {row.ref}
                  </td>
                  <td className="p-2 border border-black text-gray-800">{row.label}</td>
                  <td className="p-2 border border-black text-gray-800">{row.date}</td>
                  <td className="p-2 border border-black text-gray-800">{row.value}</td>
                  <td className="p-2 border border-black text-center text-gray-800">{row.method}</td>
                  <td className="p-2 border border-black text-gray-800"></td>
                  <td className="p-2 border border-black text-teal-800 whitespace-nowrap">
                    <FaUniversity className="inline mr-1.5 text-[#a08a50]" /> {row.bank}
                  </td>
                  <td className="p-2 border border-black text-teal-800 whitespace-nowrap">
                    <FiFileText className="inline mr-1.5 text-[#8bcf36]" /> {row.entry}
                  </td>
                  <td className="p-2 border border-black text-[#a0a0a0]">{row.acc}</td>
                  <td className="p-2 border border-black text-gray-800"></td>
                  <td className="p-2 border border-black text-right text-gray-800">{row.debit}</td>
                  <td className="p-2 border border-black text-right text-gray-800">{row.credit}</td>
                  <td className="p-2 border border-black text-center"></td>
                </tr>
              ))}
              {/* Total Row */}
              <tr className="bg-[#f5f5f5] font-medium">
                <td colSpan="10" className="p-2 border border-black text-gray-500">Total</td>
                <td className="p-2 border border-black text-right text-gray-600">
                  {totalDebit.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </td>
                <td className="p-2 border border-black text-right text-gray-600">
                  {totalCredit.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                </td>
                <td className="p-2 border border-black"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <GenericAddModal 
          isOpen={isModalOpen} 
          onClose={() => setIsModalOpen(false)} 
          onAdd={handleAdd} 
          title="Add Payment Record" 
          fields={[
            { name: 'ref', label: 'Reference' },
            { name: 'label', label: 'Label' },
            { name: 'date', label: 'Date' },
            { name: 'method', label: 'Payment Method' },
            { name: 'bank', label: 'Bank Account' },
            { name: 'acc', label: 'Account' },
            { name: 'debit', label: 'Debit Amount' }
          ]} 
        />
      </div>
    </div>
  );
}